module.exports = __webpack_public_path__ + "static/img/1031_big.c589cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1031_big.png
// module id = mGE4
// module chunks = 1